import React, { useEffect, useState } from "react";
import "./AuditionRounds.css";
import { Link, useHistory, useParams } from "react-router-dom";
import axios from "axios";
import ReactPlayer from "react-player";
import swal from "sweetalert";
import moment from "moment";
import { Markup } from "interweave";
import noImage from "../../../../assets/images/settings/no-image.png";
import { serverInfo } from "../../../../App";
import { useContext } from "react";
import LoaderPost from "../../../Reuseable/LoaderPost";

const AuditiionRoundInstructionVideoDetails = () => {
  const { imageCdnUrl,videoCdnUrl,serverUrl } = useContext(serverInfo);
  const { id } = useParams();
  const [loading, setLoading] = useState(true);

  const [event, setEvent] = useState({});

  const fetchInstructionVideoDetails = () => {
    axios
      .get(`/api/superstar/audition/round-instruction-video/details/${id}`)
      .then((res) => {
        if (res?.data?.status === 200) {
          setEvent(res?.data?.event);
          setLoading(false);
        }
      });
  };

  useEffect(() => {
    fetchInstructionVideoDetails();
  }, [id]);

  return (
    <>
      {loading === true ? (
        <LoaderPost />
      ) : (
        <>
          <>
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-6 mb-3">
                  <div className="card card-bg p-3 me-2">
                    <img
                      src={event.image ? imageCdnUrl + event.image : noImage}
                      alt=""
                      className="event-img-details img-fluid "
                    />
                  </div>
                </div>
                <div className="col-md-6 mb-3">
                  <div className="card card-bg px-3 py-2 me-2">
                    <ReactPlayer
                      url={
                        event?.video
                          ? videoCdnUrl + event?.video
                          : "https://youtu.be/dgfTiONcnTc"
                      }
                      controls
                      playing={false}
                      volume={1}
                      width="100%"

                      // height="200px" // style={{ margin: "0 auto" }}
                    />
                  </div>
                </div>
              </div>

              <div className="row mt-1">
                <div className="col-md-12">
                  <div className="card card-bg shadow">
                    <div className="card-body">
                      <h5 className="text-light pb-3">
                        {event.audition?.title}
                      </h5>

                      <h5 className="text-warning">Instruction</h5>
                      <div className="under-line"></div>
                      <p className="text-light mt-2">
                        <Markup content={event.instruction} />
                      </p>

                      <h5 className="text-warning">Description</h5>
                      <div className="under-line"></div>
                      <p className="text-light mt-2">
                        <Markup content={event.description} />
                      </p>

                      <div className="col-md-4 card card-bg-event head-line my-2 mt-4 row justify-content-between mx-0">
                        <h5 className="text-warning pt-2 ">Time Duration</h5>
                        <p className="text-light fw-bold pt-2">
                          {moment(event.start_date).format("LL")}-
                          {moment(event.end_date).format("LL")}
                        </p>
                      </div>
                      <div className="col-md-2 card card-bg-event head-line my-2 mt-4 row justify-content-between mx-0">
                        <button>
                          <a
                            href={serverUrl + event?.documnt}
                            download="instruction"
                            className="text-warning pt-2 Link"
                            target={"_blank"}
                          >
                            Download
                          </a>
                        </button>
                      </div>
                      <div className="col-md-4 card card-bg-event head-line my-2 mt-4 row justify-content-between mx-0">
                        <h5 className="text-warning pt-2 ">Feedback</h5>
                        <Link
                          to={`/superstar/auditions/round-instruction-video/create/${event.id}`}
                        >
                          <button className="btn btn-done w-100 fw-bold mt-2">
                            Create Round Instructions
                          </button>
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        </>
      )}
    </>
  );
};

export default AuditiionRoundInstructionVideoDetails;
